module.exports = __webpack_public_path__ + "img/companyIntro2.d300a087.png";